var _excluded = ["color", "shape", "size", "showFirstLastButtons", "showNexPrevButtons"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import { usePagination } from '@material-ui/lab/Pagination';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { StyledList, StyledListItem, StyledButton } from './Styles';
var getLabel = function getLabel(type) {
  if (type === 'first') {
    return 'First';
  }
  if (type === 'last') {
    return 'Last';
  }
  if (type === 'previous') {
    return 'Prev';
  }
  if (type === 'next') {
    return 'Next';
  }
  if (type === 'start-ellipsis' || type === 'end-ellipsis') {
    return /*#__PURE__*/React.createElement(MoreHorizIcon, {
      fontSize: "inherit"
    });
  }
  return null;
};
function Pagination(_ref) {
  var color = _ref.color,
    shape = _ref.shape,
    size = _ref.size,
    showFirstLastButtons = _ref.showFirstLastButtons,
    showNexPrevButtons = _ref.showNexPrevButtons,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _usePagination = usePagination(_extends({}, rest, {
      hideNextButton: !showNexPrevButtons,
      hidePrevButton: !showNexPrevButtons,
      showFirstButton: showFirstLastButtons,
      showLastButton: showFirstLastButtons
    })),
    items = _usePagination.items;
  return /*#__PURE__*/React.createElement(StyledList, null, items.map(function (item) {
    return /*#__PURE__*/React.createElement(StyledListItem, {
      key: uuid(item)
    }, /*#__PURE__*/React.createElement(StyledButton, _extends({
      color: color,
      shape: shape,
      size: size,
      type: item.type
    }, item), item.type !== 'page' && getLabel(item.type), item.type === 'page' && item.page));
  }));
}
Pagination.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Number of always visible pages at the beginning and end.
   */
  boundaryCount: PropTypes.number,
  /**
   * The color of the component. It supports those theme
   * colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'textPrimary', 'textSecondary', 'tertiary', 'error', 'warning', 'success', 'info']),
  /**
   * The total number of pages.
   */
  count: PropTypes.number,
  /**
   * The page selected by default when the component is uncontrolled.
   */
  defaultPage: PropTypes.number,
  /**
   * If `true`, the pagination component will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Callback fired when the page is changed.
   */
  onChange: PropTypes.func,
  /**
   * The current page.
   */
  page: PropTypes.number.isRequired,
  /**
   * The shape of the pagination items.
   */
  shape: PropTypes.oneOf(['round', 'rounded']),
  /**
   * If `true`, will show the first & last page buttons.
   */
  showFirstLastButtons: PropTypes.bool,
  /**
   * If `true`, will show the next & prev page buttons.
   */
  showNexPrevButtons: PropTypes.bool,
  /**
   * Number of always visible pages before and after the current page.
   */
  siblingCount: PropTypes.number,
  /**
   * The size of the pagination component.
   */
  size: PropTypes.oneOf(['large', 'small'])
} : {};
Pagination.defaultProps = {
  boundaryCount: 1,
  color: 'textPrimary',
  count: 1,
  defaultPage: 1,
  disabled: false,
  onChange: undefined,
  shape: 'round',
  showFirstLastButtons: false,
  showNexPrevButtons: true,
  siblingCount: 1,
  size: 'large'
};
export default Pagination;